import Dexie, { Table } from 'dexie'

export interface Item {
  id?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
}
export class MyDatabase extends Dexie {
  myStore!: Table<Item>

  constructor() {
    super('GJS_DB')
    this.version(1).stores({
      myStore: '++id, name'
    })
  }
}

const db = new MyDatabase()

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addItem = async (id: string, data: any): Promise<string> => {
  await db.myStore.delete(id)
  return await db.myStore.put({ id, data })
}

export const getAllItems = async (): Promise<Item[]> => {
  return await db.myStore.toArray()
}

export const getOneItem = async (id: string): Promise<Item | undefined> => {
  return await db.myStore.get(id)
}

export const deleteItem = async (id: string): Promise<void> => {
  await db.myStore.delete(id)
}

export const clearDatabase = async (): Promise<void> => {
  await db.myStore.clear()
}

export default db
